/* eslint-disable tailwindcss/no-custom-classname */
import { useBudouX } from "@/hooks/useBudouX";
import VoiceCard from "@/components/organisms/VoiceCard";

const voices = [
  {
    id: 1,
    src: "/voice-thumb1.webp",
    href: "/careers/voice/1",
    title: "上流工程から携われる環境が成長の要因",
  },
  {
    id: 6,
    src: "/voice-thumb6.webp",
    href: "/careers/voice/6",
    title: "前職のキャリアが活かすクライアントとの信頼構築",
  },
  {
    id: 7,
    src: "/voice-thumb7.webp",
    href: "/careers/voice/7",
    title: "『プロジェクトを振り返って』PMたちの声",
  },
  {
    id: 3,
    src: "/voice-thumb3.webp",
    href: "/careers/voice/3",
    title: "堅い印象のあった業界へ未経験でのチャレンジ",
  },
  {
    id: 5,
    src: "/voice-thumb5.webp",
    href: "/careers/voice/5",
    title: "柔軟に物事を決めていくスタンスに惹かれて",
  },
  {
    id: 4,
    src: "/voice-thumb4.webp",
    href: "/careers/voice/4",
    title: "課題と向き合うことで感じた成長の実感",
  },
  {
    id: 2,
    src: "/voice-thumb2.webp",
    href: "/careers/voice/2",
    title: "育児休暇を取得しやすい社内の人間関係のある環境",
  },
];

export const VoiceNav = () => {
  const { parse } = useBudouX();
  return (
    <div id="voice" className="--offset">
      <div className="grid grid-cols-2 gap-1 border-x-0 border-t-0 border-b border-solid border-bdc-light">
        <div className="box-border flex aspect-2/1 w-full grid-flow-col grid-cols-1 items-center justify-center px-8 md:px-8 lg:px-40 ">
          <div className="flex flex-col gap-4">
            <div className="font-bold">
              <h4 className=" text-ter fluid-text-[11px,16px]">メンバーの声</h4>
              <h3 className=" text-ter fluid-text-[16px,22px] ">Voice</h3>
            </div>
            <h3 className="font-bold text-pri fluid-text-[18px,32px]">
              {parse("ToccaSystemsで働くということ")}
            </h3>
            <p className="hidden leading-relaxed text-txt-light fluid-text-[11px,15px] md:block">
              {parse("お客様と向き合う仕事、未経験からの挑戦。様々なバックグラウンドを持つ仲間が活躍しています。")}
            </p>
          </div>
        </div>
        {voices.map((voice) => (
          <div key={voice.id}>
            <VoiceCard
              href={voice.href}
              src={voice.src}
              title={voice.title}
              className="grid-flow-col grid-cols-1 "
            />
          </div>
        ))}
      </div>
    </div>
  );
};
